import {Layout} from '../components/layout.jsx';

const Index = () => (
    <Layout>
      <p>这是主要内容</p>
    </Layout>
);


export default Index;